'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkstationList = function (_Component) {
  (0, _inherits3.default)(WorkstationList, _Component);

  function WorkstationList() {
    (0, _classCallCheck3.default)(this, WorkstationList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(WorkstationList).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(WorkstationList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./WorkstationList.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.cr_component },
        _react2.default.createElement('img', { className: styles.comImg, src: 'http://tupian.goeasy.cn:9999/yipinwang/header/bg_img1.jpg' }),
        _react2.default.createElement(_components.NewHeader, null),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'div',
            { className: styles.contentLeft },
            _react2.default.createElement('div', { className: styles.contentLeftMenuBackground }),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/workstation/01', className: styles.icon_di_a },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/main/gzzbg20.png', alt: '' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.contentRight },
            _react2.default.createElement('div', { className: styles.contentRightBlack }),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/', className: styles.contentRightHome },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/header/icon-home.png', alt: '' })
            )
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { className: styles.contentBottom },
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'span',
              null,
              '中华人民共和国电信与信息服务业务经营许可证编号：京ICP备07017755号'
            ),
            _react2.default.createElement(
              'span',
              null,
              '本站版权所有：中国工艺美术协会'
            )
          )
        )
      );
    }
  }]);
  return WorkstationList;
}(_react.Component); /**
                      * Created by zfc on 2017/3/6.
                      */


exports.default = WorkstationList;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/WorkstationList/WorkstationList.js
 ** module id = 1555
 ** module chunks = 0
 **/